/** @type {string} */
const tabString = 'tab';
export default tabString;
